// Module
var code = `<div class="chart-panel">
    <div class="chart-header-tool-panel" {{#if isChartHasMinSize || !showMainToolBarPanel}}style="display:none;" {{/if}}>
        <terceraAutoHidePanel>
            <terceraInstrumentLookup selectedItem="{{.instrumentItem}}" mayContainTrees="true" selectedAccount="{{.accountItem}}" />

            <accountSelector selectedItem="{{.accountItem}}" />

            <terceraButton name="overlayButton"
                           terceraButtonStyle="js-button-overlayButton"
                           visible="{{.showOverlayButton}}"
                           SVG="true"
                           on-btnClick="overlay_btnClick"
                           canCheck="true"
                           checked="{{isOverlayScreenOpen}}" />

            <terceraComboBox name="timeFrameComboBox"
                             additionalClass="time-frame-combobox"
                             on-ComboItemClicked="timeFrameComboBox_ComboItemClicked" />

            <terceraComboBox name="drawingStyleComboBox"
                             additionalClass="chart-drawing-style"
                             on-ComboItemClicked="drawingStyleComboBox_ComboItemClicked"
                             useSVGView="true"
                             showArrow="false"
                             icon="{{drawingStyleIcon}}"/>

            <terceraButton name="toolsButton"
                           terceraButtonStyle="js-button-toolsButton"
                           canCheck="true"
                           SVG="true"
                           checked="{{.showToolsPanel}}" />

            <terceraButton name="indicatorButton"
                           SVG="true"
                           terceraButtonStyle="js-button-indicatorButton"
                           on-btnClick="indicatorButton_btnClick" 
                           canCheck="true"
                           checked="{{isIndicatorLookupOpen}}" />

            <terceraButton name="objectManagerButton"
                           SVG="true"
                           canCheck="true"
                           terceraButtonStyle="js-button-objectManagerButton"
                           on-btnClick="objectManagerButton_btnClick" />

            <terceraEditableListComboBox name="editableList"
                                         isAllowSave="true"
                                         isAllowRename="true"
                                         isAllowRemove="true"
                                         isAllowRemoveLastItem="true"
                                         canHaveNoSelectedItem="true"
                                         saveTooltip="panel.menu.saveList"
                                         renameTooltip="panel.menu.renameTemplate"
                                         removeTooltip="panel.menu.removeTemplate"
                                         elementStyle="js-template-cbBtn"
                                         items="{{.items}}"
                                         storageName="chartSheets"
                                         visible="{{templatesButtonVisible}}"
                                         useSVGView="true"
                                         showArrow="false"
                                         tooltip="{{editableCBtooltip}}"
                                         newItemPlaceholder="screen.renameScreen.newTemplate.placeholder"
                                         newItemHeader="screen.renameScreen.newTemplate.header"
                                         createNew="editableComboBox.CreateNewTemplate"
                                         createNewTooltip="editableComboBox.CreateNewTemplate.tooltip"
                                         createNewIcon="add"
                                         removeTxtSecondPart="screen.remove.confirmText.secondPart.templates" />
            {{#if isGoToVisible}}
                <terceraDateSelectorLookup  cssClass="js-button-toolsButton"
                                            btnName="goToBtn"
                                            svgImage="goToBtn"
                                            tbIsVisible="false"
                                            on-changedDate="onGoToLoadingStart" 
                                            isOnlyDate="{{isGoToOnlyDate}}" 
                                            expirationTime="{{goToDate}}"
                                            btnTooltip="{{goToBtnTooltip}}"
                                            isTodayMaxMode="true"
                                            datePickerHeader="{{goToHeader}}"
                                            datePickerButtons="{{goToButtons}}" />
            {{/if}}


            <terceraButton name="mouseTradeButton"
                           terceraButtonStyle="js-button-MouseTrading"
                           canCheck="true"
                           SVG="true"
                           enabled="{{!.tradingLocked}}"
                           on-btnClick="mouseTradeButton_btnClick"
                           visible="{{.isHiddenMouseTradeButton}}" />

            <terceraButton name="orderEntry"
                           terceraButtonStyle="js-button-OrderEntry"
                           canCheck="true"
                           SVG="true"
                           checked="{{.isShowOE}}"
                           visible="{{.isHiddenOEButton}}" />

        </terceraAutoHidePanel>
    </div>
    <div class="chart-body-panel">
        <div class="chart-contents {{@this.getDrawingToolsLocation()}}">
            <terceraChartToolsPanel name="toolsPanel" visible="{{.showToolsPanel && !isChartHasMinSize}}" />
            <div class="chart-tool-panel-container"></div> 
            <div class="chart-ractive">
                <terceraChartRactive name="chart"
                                    terceraChartPanelContext="{{.terceraChartPanelContext}}" 
                                    isChartHasMinSize="{{isChartHasMinSize}}"/>

                <div class="chart-ractive-autoloading {{.autoLoadingNowClass}}">
                    <svg>
                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#loadingSpinner"></use>
                    </svg>
                </div>

                <dataSourceWidget comboBoxButtonType="false"
                                visible="{{dataSourceVisible}}"
                                opened="{{dataSourceOpen}}"
                                instrument="{{.instrumentItem}}"
                                account="{{.accountItem}}" />
                {{#if addWidgets}}
                    <terceraVisualTradingWidget name="myVisualWidget" instrumentItem="{{instrumentItem}}" accountItem="{{accountItem}}" on-closeCallback="mouseTradeButton_btnClick"/>
                    <terceraQuantityNumeric name="myTradeNumeric" isPosAbsolute="true" visible="false" />
                {{/if}}
            </div>
        </div>
        <advancedChartOrderEntry name="oe"
                         left="{{.oeLeft}}"
                         top="{{.oeTop}}"
                         visible="{{.isShowOE}}"
                         instrumentItem="{{.instrumentItem}}"
                         accountItem="{{.accountItem}}" />
    </div>
</div>`;
// Exports
export default code;